__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "login";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.101.1", () => (__webpack_require__.e(27).then(() => (() => (__webpack_require__(27))))));
			register("i18next", "25.10.10", () => (Promise.all([__webpack_require__.e(174), __webpack_require__.e(729)]).then(() => (() => (__webpack_require__(1174))))));
			register("next/compat/router", "15.5.18", () => (() => (__webpack_require__(3239))), 1);
			register("next/dynamic", "15.5.18", () => (__webpack_require__.e(776).then(() => (() => (__webpack_require__(3776))))));
			register("next/head", "15.5.18", () => (() => (__webpack_require__(8949))), 1);
			register("next/image", "15.5.18", () => (__webpack_require__.e(604).then(() => (() => (__webpack_require__(6604))))));
			register("next/link", "15.5.18", () => (() => (__webpack_require__(4043))), 1);
			register("next/router", "15.5.18", () => (() => (__webpack_require__(9774))), 1);
			register("next/script", "15.5.18", () => (__webpack_require__.e(276).then(() => (() => (__webpack_require__(4276))))));
			register("react-dom", "19.1.0", () => (() => (__webpack_require__(4518))), 1);
			register("react-hook-form", "7.80.0", () => (__webpack_require__.e(181).then(() => (() => (__webpack_require__(6181))))));
			register("react-i18next", "15.7.4", () => (__webpack_require__.e(246).then(() => (() => (__webpack_require__(5246))))));
			register("react-lazily", "0.9.2", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(1178))))));
			register("react-phone-number-input", "0", () => (__webpack_require__.e(563).then(() => (() => (__webpack_require__(3563))))));
			register("react-tooltip", "5.30.1", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(110)]).then(() => (() => (__webpack_require__(8483))))));
			register("react-dom/client", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(2181))))));
			register("react/jsx-runtime", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4489))))));
			register("react", "19.1.0", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4349))))));
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(949).then(() => (() => (__webpack_require__(9949))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(460).then(() => (() => (__webpack_require__(8460))))));
			initExternal(5197);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};